// Imports
import $ from 'jquery';
import select2 from 'select2'; // Import select2 from node_modules
import List from 'list.js'; // Import List.js from node_modules

// Hook up select2 to jQuery
select2($);

$(document).ready(function () {
	
	// Custom Promo Theme Accordions
	//----------------------------------------------
	jQuery('.advanced-accordion').each(function() {
		
		var cur = jQuery(this);
		var header_type = jQuery(this).attr('data-header-type');
		var header_lvl = jQuery(this).attr('data-header-lvl');
		var header_ele;
		
		if (header_type == 'styled' && header_lvl != 7) {
			header_ele = '> div.pane > h' + header_lvl;
		} else {
			header_ele = '> div.pane > p';
		}
	
		cur.accordion({
			header: header_ele,
			collapsible: true, // .collapsible allows an already open element to be closed
			active: cur.is('.closed') === false ? 0 : false, // .closed makes all closed by default
			heightStyle: 'content' // each panel is the height of its content, which means each panel may have a different height
		});
		
		// if the element has .open-multiple, this allows it to open more than one content area at the same time. (http://stackoverflow.com/a/15713502/781350)
		if (cur.is('.open-multiple')) {
			cur.on('accordionbeforeactivate', function(event, ui) {
				 // The accordion believes a panel is being opened
				if (ui.newHeader[0]) {
					var currHeader  = ui.newHeader;
					var currContent = currHeader.next('.ui-accordion-content');
				 // The accordion believes a panel is being closed
				} else {
					var currHeader  = ui.oldHeader;
					var currContent = currHeader.next('.ui-accordion-content');
				}
				 // Since we've changed the default behavior, this detects the actual status
				var isPanelSelected = currHeader.attr('aria-selected') == 'true';

				 // Toggle the panel's header
				currHeader.toggleClass('ui-corner-all',isPanelSelected).toggleClass('accordion-header-active ui-state-active ui-corner-top',!isPanelSelected).attr('aria-selected',((!isPanelSelected).toString()));

				// Toggle the panel's icon
				currHeader.children('.ui-icon').toggleClass('ui-icon-triangle-1-e',isPanelSelected).toggleClass('ui-icon-triangle-1-s',!isPanelSelected);

				 // Toggle the panel's content
				currContent.toggleClass('accordion-content-active',!isPanelSelected)    
				if (isPanelSelected) { currContent.slideUp(); }  else { currContent.slideDown(); }

				return false; // Cancels the default action
			});
		}
		
	});
	
	// List Search & Filter
	//----------------------------------------------
	var collection_lists = [];
	
	$('.collection-list').each(function(idx) {
		
		var cur = $(this);
		var enable_list = cur.data('list');
		var list_id = $(this).attr('id');
		
		if (enable_list) {
			
			var list_opts = {
				valueNames: ['pane-title', 'pane-content', 'pane-cat'],
				searchClass: 'main-search'
			};
			
			collection_lists.push(new List(list_id, list_opts));
			
		}
		
	});
	
	//console.log(collection_lists);
	
	$('.elon-faq-collection input.main-search').on('keyup', function() {
        
        for (var i=0; i < collection_lists.length; i++) {
	        collection_lists[i].search($('.main-search').val());    
        }
        
    });
    
    $('.elon-faq-collection select.main-filter').select2({
        placeholder: 'Filter by Category',
        allowClear: true
    });
    
    $('.elon-faq-collection select.main-filter').on('select2:select', function (e) {
        
        var data = e.params.data;
        var term = data.id;
        
        for (var i=0; i < collection_lists.length; i++) {
	        collection_lists[i].search(term);
        }
        
        $('.collection-group:not(.collection-group-' + term).hide();
        $('.collection-group-' + term).show();
        
    });
    
    $('.elon-faq-collection select.main-filter').on('select2:clear', function (e) {
	    
	    for (var i=0; i < collection_lists.length; i++) {
	        collection_lists[i].search();
        }
        
        $('.collection-group').show();
        
    });
    
    for (var i=0; i < collection_lists.length; i++) {
	    collection_lists[i].on('updated', function(list) {
		    if (list.matchingItems.length == 0) {
			    //console.log('#' + list.list.id);
				//$('#' + list.list.id).prev().hide();
				$('#' + list.list.id).prev().parent().hide();
		    } else {
				//$('#' + list.list.id).prev().show();
				$('#' + list.list.id).prev().parent().show();
		    }
	    });
    }
	
});